import ListGroup from 'react-bootstrap/ListGroup';
import { Row, Col } from 'react-bootstrap';
import Tab from 'react-bootstrap/Tab';
import { Link } from 'react-router-dom';

function Main({ activeIndex }) {
    return (
        <Tab.Container id="list-group-tabs-example" defaultActiveKey="#link1">
            <Row>
                <Col sm={12}>

                    <ListGroup>

                        <ListGroup.Item as={Link} action to="/committees" className="mb-3 p-3">
                            {/* <i className="fas fa-chevron-circle-right me-3"></i> 
                            <img className='ms-1' src="https://files.iittp.ac.in/images/demo/iit/Other/new.gif" width="36" height="20" />
                            */}
                            <b>Committees</b>
                        </ListGroup.Item>
                    </ListGroup>

                    <ListGroup>

                    <ListGroup.Item as={Link} action to="/internalcomplaintcommittee" className={`p-3 ${activeIndex == 2 ? " active" : ""}`}>
                            <i className="fas fa-chevron-circle-right me-3"></i>
                            Internal Complaint Committee  
                        </ListGroup.Item>

                        <ListGroup.Item as={Link} action to="/anti-ragging" className={`p-3 ${activeIndex == 3 ? " active" : ""}`}>
                            <i className="fas fa-chevron-circle-right me-3"></i>
                            Anti-Ragging Committee  
                        </ListGroup.Item>

                        <ListGroup.Item as={Link} action to="/liaison-officers" className={`p-3 ${activeIndex == 1 ? " active" : ""}`}>
                            <i className="fas fa-chevron-circle-right me-3"></i>
                            SC/ST/OBC Liaison Officers/Cell   
                        </ListGroup.Item>


                        <ListGroup.Item as={Link} action to="/differently_abled_support_service_cell" className={`p-3 ${activeIndex == 0 ? " active" : ""}`}>
                            <i className="fas fa-chevron-circle-right me-3"></i>
                            Differently Abled Support Service Cell
                        </ListGroup.Item>

                        <ListGroup.Item as={Link} action to="/Timetable_Committee" className={`p-3 ${activeIndex == 0 ? " active" : ""}`}>
                            <i className="fas fa-chevron-circle-right me-3"></i>
                            Timetable Committee
                        </ListGroup.Item>     



                       

                    </ListGroup>
                </Col>
                {/* <Col sm={8}>
          <Tab.Content>
            <Tab.Pane eventKey="#link1">Tab pane content 1</Tab.Pane>
            <Tab.Pane eventKey="#link2">Tab pane content 2</Tab.Pane>
          </Tab.Content>
        </Col> */}
            </Row>
        </Tab.Container>
    );
}

export default Main;

